<!-- display a warning when caps lock is on. This will show the given slot passed in-->

<template>

    <div>
        <div v-if="capsLockIsOn">
            <slot></slot>
        </div>
    </div>

</template>

<script>

    import CapsLock from '@SharedServices/caps.lock';

    export default {
        name: 'caps-lock-warning',
        data: function () {
            return {
                capsLockIsOn: false
            };
        },
        mounted: function () {
            new CapsLock().addListener(isOn => this.capsLockIsOn = isOn);
        }
    };
</script>